import {
  LOAD_SUCCESS_CHAMPS_PERSOS_GROUPES,
  LOAD_FAIL_CHAMPS_PERSOS_GROUPES,
  SAVE_SUCCESS_CHAMPS_PERSOS_GROUPES,
  SAVE_FAIL_CHAMPS_PERSOS_GROUPES,
  UPDATE_SUCCESS_CHAMPS_PERSOS_GROUPES,
  UPDATE_SUCCESS_ORDRE_CHAMPS_PERSOS,
  UPDATE_SUCCESS_ORDRE_CHAMPS_PERSOS_GROUPES,
  UPDATE_FAIL_CHAMPS_PERSOS_GROUPES,
  DELETE_SUCCESS_CHAMPS_PERSOS_GROUPES,
  DELETE_FAIL_CHAMPS_PERSOS_GROUPES,
} from "../actions/champPersoGroupeAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_CHAMPS_PERSOS_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_CHAMPS_PERSOS_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_CHAMPS_PERSOS_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_CHAMPS_PERSOS_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_CHAMPS_PERSOS_GROUPES:
      const updatedListe = [];
      state.data.forEach((item) => {
        if (
          item.champ_perso_groupe_id ===
          action.payload.champ_perso_groupe_id
        ) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_SUCCESS_ORDRE_CHAMPS_PERSOS_GROUPES:
      const updatedListeOrdre = [];
      state.data.forEach((item) => {
        if (
          item.champ_perso_groupe_id ===
          action.payload.champ_perso_groupe_id
        ) {
          item = action.payload;
        }
        updatedListeOrdre.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListeOrdre,
        error: null,
      };
    case UPDATE_SUCCESS_ORDRE_CHAMPS_PERSOS:
      const updatedListeOrdreFrom = [];
      state.data.forEach((item) => {
        if (item.champ_perso_id === action.payload.champ_perso_id) {
          item = action.payload;
        }
        updatedListeOrdreFrom.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListeOrdreFrom,
        error: null,
      };
    case UPDATE_FAIL_CHAMPS_PERSOS_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_CHAMPS_PERSOS_GROUPES:
      const filtered = state.data.filter((etape) => {
        return etape.champ_perso_groupe_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_CHAMPS_PERSOS_GROUPES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
